import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	playButton: {
		id: 'app.components.programs.MasterclassProgram.playClassButton',
		defaultMessage: 'Play Class',
		description: 'A button to play the current Calm Masterclass',
	},
	watchTrailerButton: {
		id: 'app.components.programs.MasterclassProgram.watchTrailerButton',
		defaultMessage: 'Watch Trailer',
		description: 'A button to watch the trailer for the current Calm Masterclass (a video)',
	},
});
